import Vue from 'vue';
import 'src/material/global/vendor/chart-js/Chart.min';
import moment from 'moment';
import rentalService from './../../../services/rental';
import analyticsService from './../../../services/analytics';
import mixin from './../../../mixins/mixin';
import accountService from './../../../services/account';

export default {
  data() {
    return {
      rentals: [],
      user: {
        currency: {},
      },
      channels: [],
      selectedRental: null,
      datasetsData: [],
      datasetsLabels: [],
      rentalsCount: 0,
      avgGuestCount: 0,
      year: moment().format('YYYY'),
      month: moment().format('M'),
      nightsSold: 0,
      nightsToSell: 0,
      occupancy: 0,
      analyticTableData: [],
      generalLoading: false,
      chart: {},
      occipationChart: {},
      incomeChart: {},
      totalIncome: 0,
      totalIncomePerMonth: 0,
      avgNightBooked: 0,
      avgPayout: 0,
      totalNightsSold: 0,
      totalNightsToSell: 0,
      totalOccupancy: 0,
      totalCityTaxes: 0,
      totalCommissions: 0,
      totalNetIncome: 0,
      totalCommissionPerMonth: 0,
      totalNetIncomePerMonth: 0,
      totalCityTaxesPerMonth: 0,
      totalCleaningFeesPerMonth: 0,
      nbrCheckingCheckout: 0,
      language: localStorage.getItem('lang') || 'fr',
      occupancyData: {
        label: [],
        value: [],
      },
      incomeData: {
        label: [],
        value: [],
      },
      accessToTabsStatus: {
        general: false,
        rentals: false,
        reviews: false,
        environment: false,
        market: false,
      },
      channelsIncomePerMonth: [],
      channelsIncomeChart: {},
      channelsIncomeDatasetsData: [],
      channelsIncomeDatasetsLabels: [],
      groups: [],
      shortCodeRentalGroups: [],
      checkedGroups: [],
      checkedRentals: [],
      others: [],
      yearRange: [],
      occupancyWithoutBlockedDates: 0,
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    VGenerateConcierge: require('components/generate-concierge/Concierge'),
    VExportAnalysis: require('components/export-analysis/export-analysis.vue'),
    VGenerateAnalyses: require('components/generate-analyses/index.vue'),
    VGenerateExtractor: require('components/generate-extractor/index.vue'),
    VGenerateCityTaxes: require('components/city-taxes/CityTaxesModal.vue'),
    VImportNewAirbnbRentals: require('../../account/settings/modals/ImportNewAirbnbRentals'),
  },
  mixins: [mixin],
  watch: {
    datasetsData(newData, oldData) {
      const vm = this;
      vm.datasetsData = newData;
      if (vm.datasetsData.length === 0) {
        vm.chart.data.datasets[0].data = [];
        vm.chart.data.labels = [];
      } else {
        vm.chart.data.datasets[0].data = vm.datasetsData;
        vm.chart.data.labels = vm.datasetsLabels;
      }
      vm.chart.update();
    },
    occupancyData(newData, oldData) {
      const vm = this;
      vm.occupancyData = newData;
      if (vm.occupancyData.length === 0) {
        vm.occipationChart.data.datasets[0].data = [];
        vm.occipationChart.data.labels = [];
      } else if (vm.occipationChart && vm.occipationChart.data && vm.occipationChart.data.datasets && vm.occipationChart.data.datasets[0] && vm.occipationChart.data.datasets[0].data) {
        vm.occipationChart.data.datasets[0].data = vm.occupancyData.value;
        vm.occipationChart.data.labels = vm.occupancyData.label;
      }
      if (vm.occipationChart && typeof (vm.occipationChart.update) === 'function') {
        vm.occipationChart.update();
      }
    },
    incomeData(newData, oldData) {
      const vm = this;
      vm.incomeData = newData;
      if (vm.incomeData.length === 0) {
        vm.incomeChart.data.datasets[0].data = [];
        vm.incomeChart.data.labels = [];
      } else if (vm.incomeChart && vm.incomeChart.data && vm.incomeChart.data.datasets && vm.incomeChart.data.datasets[0] && vm.incomeChart.data.datasets[0].data) {
        vm.incomeChart.data.datasets[0].data = vm.incomeData.value;
        vm.incomeChart.data.labels = vm.incomeData.label;
      }

      if (vm.incomeChart && typeof (vm.incomeChart.update) === 'function') {
        vm.incomeChart.update();
      }
    },
    'account.lang': function (newData, oldData) {
      if (oldData) {
        this.occupancyData.label = [];
        this.incomeData.label = [];
        this.analyticTableData.map((data, index) => {
          this.occupancyData.label.push(this.$t('months')[index]);
          this.incomeData.label.push(this.$t('months')[index]);
        });
        this.renderOccipationChart();
        this.renderIncomeChart();
      }
    },
    channelsIncomeDatasetsData(val) {
      this.channelsIncomeDatasetsData = val;
      if (this.channelsIncomeDatasetsData.length === 0) {
        this.channelsIncomeChart.data.datasets[0].data = [];
        this.channelsIncomeChart.data.labels = [];
      } else {
        this.channelsIncomeChart.data.datasets[0].data = this.channelsIncomeDatasetsData;
        this.channelsIncomeChart.data.labels = this.channelsIncomeDatasetsLabels;
      }
      this.channelsIncomeChart.update();
    },
  },
  async mounted() {
    const vm = this;

    mixpanel.track('web.analytics.general');
    vm.generalLoading = true;
    for (let i = 2014; i <= moment().add(2, 'years').year(); i++) {
      this.yearRange.push(i);
    }
    await accountService.fetchUserAccount(this);
    await rentalService.getRentalsList(this);
    await rentalService.getGroups(this, false, true);
    await this.getOtherRentals();
    vm.selectedRental = (vm.rentals && vm.rentals[0] && vm.rentals[0].id) && vm.rentals[0].id;

    await vm.renderChart('channel-overview', vm.chart);
    await vm.renderChart('channel-income-per-month', vm.channelsIncomeChart);
    await vm.getGeneralAnalyticData(this.checkedRentals, this.year, this.month);
    vm.renderOccipationChart();
    vm.renderIncomeChart();

    $("i[data-toggle='popover']").on('click', (e) => {
      $(e.target).popover('toggle');
    });

    $('.rental-detail-popover').on('click', (e) => {
      if ($(e.target).data('toggle') !== 'popover') {
        $('[data-toggle="popover"]').popover('hide');
      }
    });
    await this.checkAccessToTabs(this);
  },
  methods: {
    async get_rentals() {
      await rentalService.getRentalsList(this);
    },
    closeModal(selector) {
      $(selector).removeClass('show');
      $('.panel-overlay').fadeOut();
      $('body').removeClass('modal-open');
      $('div.modal-backdrop.fade.show').remove();
    },
    change_tab(tab) {
      const vm = this;
      const params = {
        id: vm.selectedRental,
      };
      if (tab == 'market') {
        params.start = moment().format('Y-MM-DD');
        params.end = moment().add(30, 'days').format('Y-MM-DD');
      }
      Vue.router.push({
        name: `analytics.${tab}.tab`,
        params,
      });
    },
    async getGeneralAnalyticData(checkedRentalIds, year = '', month = '') {
      const vm = this;
      let url = '';
      vm.generalLoading = true;
      url = '/get-general-tab-data?';

      if (year.length > 0) {
        url += `&year=${year}`;
      }
      if (month.length > 0) {
        url += `&month=${month}`;
      }
      url += `&rentals=${checkedRentalIds}`;
      await analyticsService.getGeneralTab(url, this);
    },
    renderChart(selector, chart) {
      const ctx = document.getElementById(selector).getContext('2d');
      const doughnutData = {
        labels: [],
        datasets: [{
          data: [],
          backgroundColor: [
            '#FBE6EA',
            '#F7CED5',
            '#EF9DAB',
            '#DF3A58',
            '#D7092E',
          ],
          hoverBackgroundColor: [
            '#FBE6EA',
            '#F7CED5',
            '#EF9DAB',
            '#DF3A58',
            '#D7092E',
          ],
        }],
      };
      switch (selector) {
        case 'channel-overview':
          this.chart = new Chart(ctx, {
            type: 'doughnut',
            data: doughnutData,
            options: {
              responsive: true,
              legend: {
                display: false,
              },
            },
          });
          break;
        case 'channel-income-per-month': {
          this.channelsIncomeChart = new Chart(ctx, {
            type: 'doughnut',
            data: doughnutData,
            options: {
              responsive: true,
              legend: {
                display: false,
              },
            },
          });
          break;
        }
      }
    },
    getDataForChart(ctx, labels, label, data) {
      const vm = this;
      const datasets = [];

      const gcolor = ctx.createLinearGradient(0, 0, 0, 800);
      gcolor.addColorStop(0, '#FBE6EA'); // "#fe763a3b"
      gcolor.addColorStop(0.5, '#ffffff00');
      gcolor.addColorStop(1, '#ffffff00');

      const obj = {
        label,
        data,
        backgroundColor: gcolor,
        borderColor: '#D7092E',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointBackgroundColor: '#D7092E',
      };

      datasets.push(obj);
      const doughnutData = {
        labels,
        datasets,
      };

      return doughnutData;
    },
    renderOccipationChart() {
      const vm = this;
      const stepSize = (vm.calculate_spet_size(vm.occupancyData.value) == 0) ? 1 : vm.calculate_spet_size(vm.occupancyData.value);
      vm.occipationChartCtx = document.getElementById('occupancy-chart').getContext('2d');

      vm.occipationChart = new Chart(vm.occipationChartCtx, {
        type: 'line',
        data: vm.getDataForChart(vm.occipationChartCtx, vm.occupancyData.label, vm.$t('analytics.index.occupation_chart_label'), vm.occupancyData.value),
        options: {
          tooltips: {
            position: 'nearest',
            mode: 'point',
            intersect: false,
            yPadding: 15,
            xPadding: 15,
            caretSize: 8,
            backgroundColor: '#fff',
            titleFontColor: '#000000',
            bodyFontColor: '#000000',
            borderColor: 'rgba(0,0,0,1)',
            borderWidth: 4,
          },
          hover: {
            mode: 'nearest',
            intersect: false,
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [{
              ticks: {
                fontColor: '#a2acb4',
              },
              scaleLabel: {
                display: false,
              },
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                fontColor: '#a2acb4',
                stepSize: 20,
                padding: 10,
                max: 100,
              },
              scaleLabel: {
                display: false,
              },
            }],
          },
          maintainAspectRatio: false,
        },
      });
    },
    renderIncomeChart() {
      const vm = this;
      const stepSize = (vm.calculate_spet_size(vm.incomeData.value) == 0) ? 1 : vm.calculate_spet_size(vm.incomeData.value);
      vm.incomeChartCtx = document.getElementById('income-chart').getContext('2d');
      vm.incomeChart = new Chart(vm.incomeChartCtx, {
        type: 'line',
        data: vm.getDataForChart(vm.incomeChartCtx, vm.incomeData.label, vm.$t('analytics.index.income_chart_label'), vm.incomeData.value),
        options: {
          tooltips: {
            position: 'nearest',
            mode: 'point',
            intersect: false,
            yPadding: 15,
            xPadding: 15,
            caretSize: 8,
            backgroundColor: '#fff',
            titleFontColor: '#000000',
            bodyFontColor: '#000000',
            borderColor: 'rgba(0,0,0,1)',
            borderWidth: 4,
          },
          hover: {
            mode: 'nearest',
            intersect: false,
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [{
              ticks: {
                fontColor: '#a2acb4',
              },
              scaleLabel: {
                display: false,
              },
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                fontColor: '#a2acb4',
                stepSize,
                padding: 10,
              },
              scaleLabel: {
                display: false,
              },
            }],
          },
          maintainAspectRatio: false,
        },
      });
    },
    calculate_spet_size(data) {
      const maxValue = Math.max.apply(null, data);
      let part = Math.floor(maxValue / 4);
      part = `${part}`;
      const leng = part.length;
      part = part.charAt(0);
      for (let i = 0; i < leng - 1; i++) {
        part += '0';
      }
      return part;
    },
    openImportNewRentalsModal() {
      this.$refs.airbnbImportModal.openImportNewRentalsModal();
    },
    getOtherRentals() { // get rentals which are not in any groups
      const vm = this;
      const removed = [];
      const isGroups = vm.groups.length > 0;
      // if there are not groups then all rentals will be in 'others' group
      if (!isGroups) {
        const group = {
          id: 0,
          name: this.$t('groups.all'),
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      for (let i = 0; i < vm.rentals.length; i++) {
        const rental = vm.rentals[i];
        for (let j = 0; j < vm.groups.length; j++) {
          const group = vm.groups[j];
          const check = group.rentals.filter(r => r.id === rental.id);
          if (check.length > 0) {
            const check1 = vm.others.filter(r => r.id === rental.id);
            if (check1.length > 0) {
              const index = vm.others.indexOf(rental);
              vm.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = vm.others.filter(r => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              vm.others.push(rental);
            }
          }
        }
      }
      // add group with rentals which are not in any groups
      if (isGroups) {
        const group = {
          id: 0,
          name: this.$t('groups.others'),
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      return vm.others;
    },
    filterByRentals(id = null) {
      const vm = this;
      if (id != null) {
        const group = vm.groups.filter(g => g.id === id)[0];
        const groupRentals = group.rentals;
        for (let i = 0; i < groupRentals.length; i += 1) {
          Vue.set(vm.checkedRentals, groupRentals[i].id, vm.checkedGroups[id]);
        }
      }

      for (let i = 0; i < vm.groups.length; i += 1) {
        const group = vm.groups[i];
        for (let j = 0; j < group.rentals.length; j += 1) {
          const rental = group.rentals[j];
          if (!vm.checkedRentals[rental.id]) {
            Vue.set(vm.checkedGroups, group.id, false);
            break;
          }
          Vue.set(vm.checkedGroups, group.id, true);
        }
      }

      this.getGeneralAnalyticData(this.getCheckedRentalIds(this.checkedRentals), this.year, this.month);
    },
    getCheckedRentalIds(checkedRentalData) {
      const checkedRentalIds = [];
      for (const i in checkedRentalData) {
        checkedRentalData[i] === true && checkedRentalIds.push(parseInt(i));
      }
      return checkedRentalIds;
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/analytics/general/general.js